import { render, staticRenderFns } from "./franchisee-register.vue?vue&type=template&id=32354ef7&scoped=true&"
import script from "./franchisee-register.vue?vue&type=script&lang=js&"
export * from "./franchisee-register.vue?vue&type=script&lang=js&"
import style0 from "./franchisee-register.vue?vue&type=style&index=0&id=32354ef7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32354ef7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PromoHome: require('/home/circleci/repo/components/PromoHome.vue').default})
